export const GET_ALL_PLATE = "GET_ALL_PLATE";
